import { AVAILABLE_LANGUAGES } from './available-languages';

export const AVAILABLE_LANGUAGES_NAMES = {
  [AVAILABLE_LANGUAGES.ES]: 'Español',
  [AVAILABLE_LANGUAGES.EN]: 'English',
  [AVAILABLE_LANGUAGES.IT]: 'Italiano',
} as const;
